<script lang="ts" setup>
/* eslint-disable vue/no-v-html */
import { ApiAdditionalInsurance } from '~~/server/api/insurance/additional/insurance'

const route = useRoute()
const { data: page, redirect } = await useFetchWithRedirect<ApiAdditionalInsurance>(
    '/api/insurance/additional/insurance',
    {
        route
    }
)

if(redirect && !redirect?.error) {
    navigateTo(redirect.data.url, redirect.data.options)
}

const { $formatTableHtml } = useNuxtApp()

// Schema.org
useSchemaOrg([
    defineWebPage({
        name: page.value?.data.title,
        image: page.value?.data.headline.image.path['1540x0']?.url || '',
    }),
])

// Page meta
usePageMeta({
    meta: page.value?.data.meta,
    title: page.value?.data.title,
})
</script>
<template>
  <article v-if="page">
    <Tracker
      :data="{
        position: page.data.title,
        title: page.data.additional_insurances.title || '',
      }"
    >
      <ContainerFluid>
        <Breadcrumbs
          :current="page.data.title"
          :links="[]"
        />
      </ContainerFluid>
      <PageHeader
        :title="page.data.title"
        :headline="page.data.headline"
        class="mb-12 mb-md-20"
      />
      <ContainerFluid class="mt-md-12 mt-md-30">
        <Box
          v-if="page.data.description.title"
          color="gray"
          decor-position="top-left"
          padding="px-6 py-10 p-lg-15"
          class="mb-12 mb-md-20 text-center"
        >
          <h2 class="alfa mb-4 mb-12">
            {{ page.data.description.title }}
          </h2>
          <Typo v-if="page.data.description.content">
            <div
              class="lead"
              v-html="$formatTableHtml(page.data.description.content)"
            />
          </Typo>
        </Box>
        <h3
          v-if="page.data.additional_insurances.title"
          class="beta text-center mb-12 mb-md-20"
        >
          {{ page.data.additional_insurances.title }}
        </h3>
        <LazyBox
          color="gray"
          decor-position="top-right"
          class="mb-12 mb-md-20"
        >
          <LazyLinkBox
            v-for="(item, index) in page.data.additional_insurances
              .data"
            :key="`iaii-${index}`"
            :class="{
              'mb-2':
                index <
                page.data.additional_insurances.data.length - 1,
            }"
            :to="{
              name: 'additional-insurance-detail',
              params: { id: item.slug },
            }"
            :label="item.title"
          >
            {{ item.title }}
          </LazyLinkBox>
        </LazyBox>
        <div class="pt-12 pt-md-20 border-top">
          <LazyWidgetHelpdeskExt />
        </div>
      </ContainerFluid>
    </Tracker>
  </article>
</template>
